import React from "react";
import { ArrowRight } from "lucide-react";
import { After, New, Note, Was, Wrap } from "./ValueChange.styles";
import type { ValueChangeProps } from "./ValueChange.types";

/** A cell's value before and after a change. */
export const ValueChange: React.FC<ValueChangeProps> = ({ before, after, emptyLabel, icon, note, appearance = "chip" }) => {
  const empty = !before.trim();
  const columns = appearance === "columns";
  const newValue =
    after !== null ? (
      <New $plain={appearance !== "chip"}>
        {icon ? <span aria-hidden="true">{icon}</span> : null}
        {after}
      </New>
    ) : null;
  const noteText = note ? <Note>· {note}</Note> : null;
  return (
    <Wrap data-changed={after !== null} $columns={columns}>
      <Was $empty={empty} $struck={after !== null && !empty}>
        {empty ? emptyLabel : before}
      </Was>
      {after !== null ? <ArrowRight aria-hidden="true" /> : null}
      {columns ? (
        <After>
          {newValue}
          {noteText}
        </After>
      ) : (
        <>
          {newValue}
          {noteText}
        </>
      )}
    </Wrap>
  );
};

export default ValueChange;
